import { html } from 'lit';
import { ChevronRight } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-chevron-right')
export class PdsIconChevronRight extends PdsIcon {
  @state()
  icon = ChevronRight;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
